<template>
  <div class="order-modal order-modal_mw380">
    <div class="order-modal__head">
      <div class="order-modal__title mb10">
        <span>{{ $t("orders.paymentType") }}</span>

        <button @click="close" class="order-modal__address-close">
          <img src="@/assets/images//close.svg" width="24px" alt />
        </button>
      </div>
    </div>

    <div class="order-modal__body p30">
      <div class="payment-options">
        <div
          class="payment-option mb16"
          @click="chooseOption('cash')"
          :class="{
            'payment-option_active': type == 'cash',
          }"
        >
          <div class="payment-option__image">
            <img src="@/assets/images/coin.png" alt />
          </div>
          <div class="payment-option__info">
            <p class="payment-option__text">{{ $t("orders.cash") }}</p>
          </div>
        </div>

        <div
          class="payment-option mb16"
          @click="chooseBill"
          :class="{
            'payment-option_active': type == 'bill',
          }"
        >
          <div class="payment-option__image">
            <img src="@/assets/images/card.svg" alt />
          </div>
          <div class="payment-option__info">
            <p class="payment-option__text">{{ $t("orders.getTheBill") }}</p>
          </div>
        </div>

        <div
          v-if="isProfy"
          class="payment-option mb30"
          @click="chooseOption('card')"
          :class="{
            'payment-option_active': type == 'card',
          }"
        >
          <div class="payment-option__image">
            <img src="@/assets/images/union.svg" alt />
          </div>
          <div class="payment-option__info">
            <p class="payment-option__text">Visa/Mastercard</p>
          </div>
        </div>
      </div>

      <div class="order-modal__info order-modal__info_center">
        <button class="btn btn_w240" @click="doAction">{{ $t("buttons.continue") }}</button>
      </div>

      <main-modal
        :show="isOpenBillingModal"
        :className="'address-modal'"
        @close="closeBillingModal"
      >
        <add-billing-address @close="closeBillingModal" @done="saveBillingAddress" />
      </main-modal>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import addBillingAddress from "@/components/modals/address/addBillingAddress";
import mainModal from "@/components/modals/mainModal";

export default {
  data() {
    return {
      type: "cash",
      isOpenBillingModal: false
    };
  },
  components: {
    addBillingAddress,
    mainModal
  },
  computed: {
    ...mapGetters({
      order: "orders/order"
    }),
    isProfy() {
      return this.$config.project == "profy";
    },
    isProd() {
      return this.$config.key == "prod";
    }
  },
  methods: {
    ...mapMutations({
      setState: "main/setState",
      setIsComponent: "orders/setIsComponent",
      setAddressState: "address/setState"
    }),
    ...mapActions({
      update: "orders/update",
      createBillingAddress: "address/addBillingAddress",
      fetchBillingAddress: "address/fetchBillingAddress"
    }),
    chooseBill() {
      this.openBillingModal();
    },
    close() {
      this.setState({
        key: "mainModal",
        value: false
      });
    },
    async chooseOption(type) {
      this.type = type;
    },
    async doAction() {
      await this.update({
        id: this.order.id,
        form: {
          status: "payment",
          payment_type: this.type
        }
      });

      if (this.type == "card" && this.order.status == "payment") {
        console.log("open myPOS");
        this.setIsComponent("paymentWidget");
      } else {
        this.$emit("fetch");
        this.close();
      }
    },
    openBillingModal() {
      this.isOpenBillingModal = true;
    },
    closeBillingModal() {
      this.isOpenBillingModal = false;
    },
    async saveBillingAddress() {
      const response = await this.createBillingAddress();
      const isOkey = response.status === 200 || response.status === 201;

      if (!isOkey) return;

      await this.fetchBillingAddress();

      this.chooseOption("bill");
      await this.doAction();
      this.closeBillingModal();
    }
  },
  mounted() {
    this.fetchBillingAddress();
  }
};
</script>

<style lang="scss" scoped>
.order-modal {
  &_mw380 {
    max-width: 380px;
    margin: 0 auto;
    position: relative;
  }

  &__paylink {
    display: inline-block;
    margin: 0 auto;
    text-decoration: none;
    font-size: 14px;
    color: #898989;

    &:hover {
      text-decoration: underline;
    }
  }
}

.payment {
  &-option {
    display: flex;
    align-items: center;
    padding: 26.5px 16px;
    box-shadow: 0px 30px 50px rgba(155, 205, 130, 0.2);
    background-color: #fff;
    transition: all 0.3s ease-in;

    &:hover {
      cursor: pointer;
      background: rgba(155, 205, 130, 0.4);
    }

    &_active {
      box-shadow: unset;
      background: rgba(155, 205, 130, 0.2);
    }

    &__image {
      margin-right: 16px;
    }

    &__text {
      font-size: 16px;
      line-height: 120%;
      display: flex;
      align-items: center;
      letter-spacing: 0.02em;
      color: #828282;
      font-family: "crosten-bold";
    }
  }
}
</style>
